import { render } from "./CookieAlert.vue?vue&type=template&id=1d53bc0c&lang=pug"
import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/coral-cookie/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__